export const PROJECTION_OPERATIONS = {
  SUM: {
    value: "SUM",
    label: "Sum",
    short: "SUM",
    requiresSource: true,
    badgeClass: "fmp-op-sum",
    description: "Aggregate a numeric item field into the head field.",
    rules: [
      "Source item field: required, additive numeric (not an identifier or serial no)",
      "Target head field: numeric (int, decimal, float, double)",
      "New numeric target length: 1 to 65",
      "Example: quantity → total_quantity",
    ],
    newFieldDataTypes: ["decimal", "float", "double", "int", "bigint"],
    defaultDataType: "decimal",
    defaultFieldType: "DECIMAL",
    defaultLength: 18,
  },
  COPY_ONE: {
    value: "COPY_ONE",
    label: "First item value",
    short: "COPY ONE",
    requiresSource: true,
    badgeClass: "fmp-op-copy",
    description:
      "Copy the value from the first item ordered by serial_no, then id.",
    rules: [
      "Source item field: required, display type (string, char, text)",
      "Target head field: string/char with length ≥ source length",
      "Copies the first item row ordered by serial_no, then id",
      "Example: product_name → head_product_name",
    ],
    newFieldDataTypes: ["string", "char"],
    defaultDataType: "string",
    defaultFieldType: "STRING",
    defaultLength: 100,
  },
  COUNT_ROWS: {
    value: "COUNT_ROWS",
    label: "Count rows",
    short: "COUNT ROWS",
    requiresSource: false,
    badgeClass: "fmp-op-count",
    description: "Count item rows for each transaction.",
    rules: [
      "Source item field: not required",
      "Target head field: integer type (int, bigint, smallint)",
      "Counts the number of item rows per transaction",
      "Example: (item rows) → total_line_items",
    ],
    newFieldDataTypes: ["int", "bigint"],
    defaultDataType: "int",
    defaultFieldType: "INTEGER",
    defaultLength: 11,
  },
};

export const PROJECTION_OPERATION_ORDER = ["SUM", "COPY_ONE", "COUNT_ROWS"];

export const PROJECTION_DATA_TYPE_LABELS = {
  int: "Integer",
  bigint: "Big Integer",
  smallint: "Small Integer",
  decimal: "Decimal",
  float: "Float",
  double: "Double",
  string: "String",
  char: "Char",
};

export const PROJECTION_FIELD_TYPES = [
  { value: "DECIMAL", label: "Decimal" },
  { value: "INTEGER", label: "Integer" },
  { value: "STRING", label: "String" },
  { value: "TEXT", label: "Text" },
];

export const NUMERIC_TARGET_MAX_LENGTH = 65;
export const COPY_ONE_TARGET_MAX_LENGTH = 16383;
export const FIELD_NAME_PATTERN = /^[A-Za-z_][A-Za-z0-9_]*$/;
export const FIELD_NAME_MAX_LENGTH = 31;
export const FIELD_TITLE_MAX_LENGTH = 100;
